import { render, staticRenderFns } from "./profileoverview.vue?vue&type=template&id=b0b5b888&scoped=true"
import script from "./profileoverview.vue?vue&type=script&lang=js"
export * from "./profileoverview.vue?vue&type=script&lang=js"
import style0 from "./profileoverview.vue?vue&type=style&index=0&id=b0b5b888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b5b888",
  null
  
)

export default component.exports